import { Link } from 'react-router'

export function NotFound() {
  return (
    <div className="stack stack--reading">
      <div className="card not-found">
        <h1>That page does not exist.</h1>
        <p className="page__lead">
          The link may be out of date, or the screen may have moved.
        </p>
        <Link className="btn btn--secondary" to="/">Back to Home</Link>
      </div>
    </div>
  )
}
